<template>
    <div class="page_box_news item-module-info" style="position: relative;top:150px;">

        <div class="fullSlide1" style="width: 1653px;margin: 0 auto;">
            <div class="bd">
                <ul>
                    <li style="background:url(../static/img/banner2.jpg) top center no-repeat;">
                        <a>&nbsp;</a>
                    </li>
                </ul>
            </div>
        </div>

        <span class="layui-breadcrumb" style="visibility: visible;margin: 35px auto;width: 1653px;">
            <a class="shouye" @click="homePage()">首页</a><span lay-separator="">/</span>
            <a class="f-nav" @click="notic()">{{navigationName}}</a><span lay-separator="">/</span>
            <a class="target-text">
                <cite style="color: #f08326!important;">{{title}}</cite>
            </a>
        </span>

        <div class="item-module-info-content">
            <h1 class="text-center page_box_news_title"><b>{{title}}</b></h1>
            <h2
                style="font-size:14px; text-align:center; margin:0px 0;font:400 14px/28px Microsoft YaHei,simhei,Arial;color:#999;">
                时间：{{insertTime}}&nbsp;&nbsp;浏览次数：<span>{{viewNum}}</span>次</h2>
            <hr>
            <v-spin :spinning="loadingFlag" tip="" size="large">
                <div v-html="desc" style="margin: auto 125px;min-height: 200px;" id="richtext"></div>


                <ul v-if="attchments.length > 0" style="margin: auto 125px;">
                    <li v-for="(item,index) in attchments" style="cursor: pointer;" @click="detailDownload(item)">
                        <i class="layui-icon layui-icon-download-circle"></i>考试文件.txt

                    </li>


                    <!-- <li><a download="考试文件.txt" href="https://jnrd.zcyunedu.com/jnrd/static-ueditor/1635983075327.txt"><i class="layui-icon layui-icon-download-circle"></i>考试文件.txt</a></li> -->
                </ul>
            </v-spin>



            <div style="margin:35px;">
                <p style="border-bottom: 1px dashed #CCC;">&nbsp;</p>
                <p style="width:50%;float:left;font-size: 14px;white-space:nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                width: 400px;">上一篇:
                    <a v-if="prevTitle !=null" @click="previousPosts()"
                        style="color:#747474;font-size: 14px;">{{prevTitle}}</a>
                    <a v-if="prevTitle ==null" style="color:#747474;font-size: 14px;">暂无</a>
                </p>

                <p style="float:right;font-size: 14px;white-space:nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                width: 400px;">下一篇:

                    <a v-if="nextTitle !=null" @click="nextChapter()"
                        style="color:#747474;font-size: 14px;">{{nextTitle}}</a>

                    <a v-if="nextTitle ==null" style="color:#747474;font-size: 14px;">暂无</a>
                </p>
                <p style="border-bottom: 1px dashed #CCC;">&nbsp;</p>

            </div>

        </div>
    </div>
</template>

<script>
    //import homePage from './components/homePage.vue';
    export default {
        name: 'app',
        components: {
            //homePage
        },
        data() {
            return {
                loadingFlag: false,
                desc: '',
                title: '',
                insertTime: '',
                nextTitle: '',
                nextId: 0,
                prevId: 0,
                prevTitle: '',
                viewNum: 0,
                navigationName: '',
                attchments: []
            }
        },
        async  created() {

            this.navigationName = this.$route.params.navName

            console.log(this.$route.params.id)
            await this.loadDetail(this.$route.params.id);


            //获取所有 img 标签
            let length = document.getElementById('richtext').getElementsByTagName('img').length;

            for (var i = 0; i < length; i++) {
                let img = document.getElementById('richtext').getElementsByTagName('img')[i];
                let src = img.src;
                let strArray = src.split('/');
                img.src = this.serverUrl + this.prefiexUrl + strArray[strArray.length - 1];
            }
        },
        methods: {

            detailDownload(item) {
                console.log(item);
                //window.location.href=this.serverUrl + this.prefiexUrl + item.attchmenSrc;

                window.open(this.serverUrl + this.prefiexUrl + item.attchmenSrc,'_self');

                // window.location.href = 'https://jnrd.zcyunedu.com/jnrd/static-ueditor/' + item.attchmenSrc

                //2.给a标签的href赋上下载地址
                //a.href = 'https://jnrd.zcyunedu.com/jnrd/static-ueditor/' + item.attchmenSrc;
            },
            homePage() {

                this.$router.push({ path: '/' })

            },
            notic() {
                let navId = '';
                if (this.navigationName === '报名须知') {
                    navId = '1';
                } else if (this.navigationName === '政策文件') {
                    navId = '2';
                } else if (this.navigationName === '实时新闻') {
                    navId = '3';
                } else if (this.navigationName === '通知公告') {
                    navId = '4';
                } else if (this.navigationName === '关于我们') {
                    navId = '5';
                } else if (this.navigationName === '职业标准') {
                    navId = '6';
                }else if (this.navigationName === '招生信息') {
                    navId = '7';
                }

                this.$router.push({ path: '/journalismNotice/' + navId })
            },
            previousPosts() {
                this.$router.push({ path: '/journalismNoticeDetail/' + this.prevId + "/" + this.navigationName });
                this.$router.go(0);
            },
            nextChapter() {
                this.$router.push({ path: '/journalismNoticeDetail/' + this.nextId + "/" + this.navigationName });
                this.$router.go(0);
            },
            loadDetail(id) {
                this.loadingFlag = true;
                return new Promise((resolve, reject) => {
                    let parames = new URLSearchParams();
                    parames.append('id', id);
                    this.$axios.post(this.serverUrl + '/navCInfo', parames).then(resp => {

                        if (resp.data.code === 1) {
                            this.desc = resp.data.data.contentDesc;
                            this.title = resp.data.data.contentTitle;
                            this.insertTime = resp.data.data.insertTime.substring(0, 10);
                            this.viewNum = resp.data.data.viewNum;
                            this.nextId = resp.data.data.nextId;
                            this.nextTitle = resp.data.data.nextTitle;
                            this.prevId = resp.data.data.prevId;
                            this.prevTitle = resp.data.data.prevTitle;
                            this.attchments = resp.data.data.attchments;
                        }

                        this.loadingFlag = false;
                        resolve();
                    }).catch(err => {
                        this.$message({
                            message: '服务器繁忙！',
                            type: 'warning'
                        });
                    })
                })
            }
        }
    }
</script>
<style scoped>
    .layui-breadcrumb {
        display: block;
        width: 100%;
        height: 40px;
        background-color: #fdf9d6;
        border: 1px solid #e4e3c5;
        line-height: 40px;
        padding: 0 15px;
    }

    .layui-breadcrumb {
        font-size: 0;
    }

    .bd {
        margin: 0 auto;
        width: 100% !important;
        position: relative;
        z-index: 0;
    }

    h2 {
        display: block;
        font-size: 1.5em;
        margin-block-start: 0.83em;
        margin-block-end: 0.83em;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
        font-weight: bold;
    }

    .page_box_news_title b {
        display: block;
        color: #333;
        font-size: 24px;
        padding-top: 10px;
    }

    h1 {
        display: block;
        font-size: 2em;
        margin-block-start: 0.67em;
        margin-block-end: 0.67em;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
        font-weight: bold;
    }

    .text-center {
        text-align: center;
        margin-bottom: 15px;
    }

    .page_box_news_title {
        width: 100%;
        height: auto;
        overflow: hidden;
        text-align: center;
        color: #888888;
        font-size: 14px;
    }

    .page_box_news {
        width: auto;
        height: auto;
        min-height: 800px !important;
        overflow: hidden;
        margin: 0 auto;
        line-height: 40px;
        color: #333;
        font-size: 16px;
        border-radius: 8px;
    }

    blockquote,
    body,
    button,
    dd,
    div,
    dl,
    dt,
    form,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    input,
    li,
    ol,
    p,
    pre,
    td,
    textarea,
    th,
    ul {
        margin: 0;
        padding: 0;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }
</style>


// WEBPACK FOOTER //
// src/components/journalismNoticeDetail.vue